import { HierarchyBrowserEvents, useRefreshQueriesOn } from '@/lib/browser-events'
import { useSelectedEntityId } from '@/lib/use-selected-entity'

import { userManagementEntityKeys } from './user-management-entity-queries'

export function AccessHierarchyBrowserEvents(): React.ReactNode {
  const entityId = useSelectedEntityId()
  return entityId ? <AccessHierarchyBrowserEventSubscriptions entityId={entityId} /> : null
}

function AccessHierarchyBrowserEventSubscriptions({
  entityId,
}: {
  entityId: string
}): null {
  const events = HierarchyBrowserEvents.for({ entityId })
  useRefreshQueriesOn(events.capabilitiesChanged, [userManagementEntityKeys.root])
  return null
}
